/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Status_InterviewInputs */

const en_jobs_status_interview = /** @type {(inputs: Jobs_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview`)
};

const de_jobs_status_interview = /** @type {(inputs: Jobs_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorstellungsgespräch`)
};

const fr_jobs_status_interview = /** @type {(inputs: Jobs_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entretien`)
};

const es_jobs_status_interview = /** @type {(inputs: Jobs_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrevista`)
};

const it_jobs_status_interview = /** @type {(inputs: Jobs_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colloquio`)
};

const nl_jobs_status_interview = /** @type {(inputs: Jobs_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatiegesprek`)
};

const pl_jobs_status_interview = /** @type {(inputs: Jobs_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozmowa kwalifikacyjna`)
};

const fi_jobs_status_interview = /** @type {(inputs: Jobs_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työhaastattelu`)
};

const da_jobs_status_interview = /** @type {(inputs: Jobs_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobsamtale`)
};

const sv_jobs_status_interview = /** @type {(inputs: Jobs_Status_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobbintervju`)
};

/**
* | output |
* | --- |
* | "Interview" |
*
* @param {Jobs_Status_InterviewInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_status_interview = /** @type {((inputs?: Jobs_Status_InterviewInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Status_InterviewInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_status_interview(inputs)
	if (locale === "fr") return fr_jobs_status_interview(inputs)
	if (locale === "es") return es_jobs_status_interview(inputs)
	if (locale === "it") return it_jobs_status_interview(inputs)
	if (locale === "nl") return nl_jobs_status_interview(inputs)
	if (locale === "pl") return pl_jobs_status_interview(inputs)
	if (locale === "fi") return fi_jobs_status_interview(inputs)
	if (locale === "da") return da_jobs_status_interview(inputs)
	if (locale === "sv") return sv_jobs_status_interview(inputs)
	return en_jobs_status_interview(inputs)
});